import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { walldata } from '../Config/wallcoveringabstractdata';
import WallCards from "../Components/wallcoveringabstractCards";
import OurInformation from '../Components/OurInformation';
import AddToWishlistButton from "../Components/AddToWishlistButton";

// Component for Mobile View
const WallcoveringsabstractMobile = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden px-2 sm:px-5">
      <div className='services__area pt-10 hidden sm:block' id='services'>
      </div>

      <div className='grid grid-cols-2 gap-2 max-[640px]:grid-cols-2 max-[640px]:px-0 justify-items-center'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div
            className="w-full max-[640px]:px-1 relative"
            key={index}
            ref={(el) => {
              if (el) cardRefs.current[index] = el;
            }}
          >
            <Link to={`/wallcoverings/abstract/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                title={it.title}
                btn={it.btn}
                isDesktop={false}
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
}

// Component for Tablet View
const WallcoveringsabstractTablet = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden px-3 pt-10">
      <div className='services__area hidden sm:block' id='services'>
      </div>

      <div className='grid grid-cols-2 gap-3 justify-items-center'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div
            className="w-full max-w-[160px] relative"
            key={index}
            ref={(el) => {
              if (el) cardRefs.current[index] = el;
            }}
          >
            <Link to={`/wallcoverings/abstract/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                title={it.title}
                btn={it.btn}
                isDesktop={false}
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
};

// Component for Mid-Desktop View
const WallcoveringsabstractMidDesktop = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden px-4 pt-14">
      <div className='services__area hidden sm:block' id='services'>
      </div>

      <div className='grid grid-cols-3 gap-4 justify-items-center'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div
            className="w-full max-w-[260px] relative"
            key={index}
            ref={(el) => {
              if (el) cardRefs.current[index] = el;
            }}
          >
            <Link to={`/wallcoverings/abstract/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                title={it.title}
                btn={it.btn}
                isDesktop={false}
                customStyle="w-full h-[180px] object-cover scale-105"
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
};

// Component for Laptop View
const WallcoveringsabstractLaptop = ({ visibleItems, lastCardRef, cardRefs }) => {
  return (
    <div className="overflow-hidden p-0 sm:p-5 pt-20">
      <div className='services__area pt-10 hidden sm:block' id='services'>
      </div>

      <div className='grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center max-w-[1400px] mx-auto px-4'>
        {walldata.slice(0, visibleItems).map((it, index) => (
          <div
            className="w-full sm:w-auto relative"
            key={index}
            ref={(el) => {
              if (el) cardRefs.current[index] = el;
            }}
          >
            <Link to={`/wallcoverings/abstract/desc/${index + 1}`}>
              <WallCards
                ImgSrc={it.Img}
                ImgJpg={it.ImgJpg}
                title={it.title}
                btn={it.btn}
                isDesktop={true}
                item={it}
                showWishlistButton={false}
              />
            </Link>
            <div className="absolute top-2 right-2 z-20" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
              <AddToWishlistButton 
                item={it}
                size="small"
              />
            </div>
          </div>
        ))}
      </div>
      {/* Invisible div that the IntersectionObserver will watch */}
      {visibleItems < walldata.length && <div ref={lastCardRef} className="h-1" />}
    </div>
  );
};

const Wallcoveringsabstract = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const scrollToId = searchParams.get('scrollTo');
  
  console.log('[WallcoveringAbstract] Component rendered - scrollToId from URL:', scrollToId, 'Full URL:', location.pathname + location.search);
  
  // Always prioritize sessionStorage over URL parameter (sessionStorage has the latest viewed image)
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    const lastViewedId = sessionStorage.getItem('lastViewedImageIdWallcoveringabstract');
    
    console.log('[WallcoveringAbstract] Checking - scrollToId in URL:', currentScrollToId, 'lastViewedId in storage:', lastViewedId);
    
    // Always prioritize sessionStorage if it exists (it has the most recent viewed image)
    if (lastViewedId) {
      // If URL has a different scrollToId than sessionStorage, update URL to use sessionStorage value
      if (currentScrollToId !== lastViewedId) {
        console.log('[WallcoveringAbstract] sessionStorage has different value than URL. Updating URL to use latest:', lastViewedId);
        const newSearchParams = new URLSearchParams(location.search);
        newSearchParams.set('scrollTo', lastViewedId);
        navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
        // Clear sessionStorage after using it
        sessionStorage.removeItem('lastViewedImageIdWallcoveringabstract');
        console.log('[WallcoveringAbstract] Updated URL with scrollTo from sessionStorage and cleared sessionStorage');
      } else {
        // They match, so clear sessionStorage to avoid conflicts
        console.log('[WallcoveringAbstract] URL and sessionStorage match, clearing sessionStorage');
        sessionStorage.removeItem('lastViewedImageIdWallcoveringabstract');
      }
    } else if (currentScrollToId) {
      // No sessionStorage but URL has scrollToId - this is fine, just log it
      console.log('[WallcoveringAbstract] Using scrollToId from URL:', currentScrollToId);
    } else {
      // Neither exists - normal navigation without scroll
      console.log('[WallcoveringAbstract] No scrollToId in URL and no lastViewedId in storage');
    }
  }, [location.pathname, location.search, navigate]);
  
  // State to manage the number of visible items, starting with 20.
  const [visibleItems, setVisibleItems] = useState(20);
  const [screenType, setScreenType] = useState('mobile');
  const [hasScrolledToTarget, setHasScrolledToTarget] = useState(false);

  // Reset scroll state when scrollToId changes
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    if (currentScrollToId) {
      console.log('[WallcoveringAbstract] scrollToId changed, resetting hasScrolledToTarget');
      setHasScrolledToTarget(false);
    }
  }, [location.search]);

  // Using useRef to hold the observer instance.
  const observer = useRef();
  const cardRefs = useRef({});
  
  // useCallback is used to create a ref function that is stable across re-renders.
  // This ref function will be called by React when the element is mounted/unmounted.
  const lastCardRef = useCallback(node => {
    // If we are already observing, stop observing the previous element.
    if (observer.current) {
      observer.current.disconnect();
    }
    
    // Create a new IntersectionObserver.
    observer.current = new IntersectionObserver(entries => {
      // If the last element is intersecting, and we still have more data, load more items.
      if (entries[0].isIntersecting && visibleItems < walldata.length) {
        setVisibleItems(prevItems => Math.min(prevItems + 20, walldata.length));
      }
    }, {
      rootMargin: '400px 0px',
    });

    // If there is a node (the invisible div), start observing it.
    if (node) {
      observer.current.observe(node);
    }
  }, [visibleItems]); // visibleItems is a dependency to ensure the observer's callback has the latest state.

  // Handle scrolling to target image - direct scroll without transition
  useEffect(() => {
    const currentScrollToId = new URLSearchParams(location.search).get('scrollTo');
    console.log('[WallcoveringAbstract] Scroll effect triggered - scrollToId:', currentScrollToId, 'hasScrolledToTarget:', hasScrolledToTarget, 'visibleItems:', visibleItems);
    
    if (currentScrollToId && !hasScrolledToTarget) {
      const targetIndex = parseInt(currentScrollToId) - 1; // Convert ID to 0-based index
      console.log('[WallcoveringAbstract] Target index calculated:', targetIndex, 'from scrollToId:', currentScrollToId);
      
      // Ensure enough items are loaded to include the target
      if (targetIndex >= visibleItems) {
        const newVisibleItems = Math.max(visibleItems, targetIndex + 10);
        console.log('[WallcoveringAbstract] Not enough items loaded. Current:', visibleItems, 'Target index:', targetIndex, 'Loading more:', newVisibleItems);
        setVisibleItems(newVisibleItems); // Load more items if needed
        return; // Wait for items to load
      }
      
      // Multiple attempts to scroll with increasing delays for mobile reliability
      const attemptScroll = (attempt = 1) => {
        console.log(`[WallcoveringAbstract] Attempt ${attempt} to scroll to index:`, targetIndex);
        const targetElement = cardRefs.current[targetIndex];
        console.log('[WallcoveringAbstract] Target element found:', !!targetElement);
        
        if (targetElement) {
          console.log('[WallcoveringAbstract] Scrolling to element');
          targetElement.scrollIntoView({
            behavior: 'auto', // Direct scroll without transition
            block: 'center'
          });
          setHasScrolledToTarget(true);
          console.log('[WallcoveringAbstract] Scroll completed successfully');
          return true;
        }
        console.log('[WallcoveringAbstract] Target element not found, will retry');
        return false;
      };

      // First attempt after 200ms
      const timer1 = setTimeout(() => {
        console.log('[WallcoveringAbstract] First scroll attempt');
        if (!attemptScroll(1)) {
          // Second attempt after 400ms
          setTimeout(() => {
            console.log('[WallcoveringAbstract] Second scroll attempt');
            if (!attemptScroll(2)) {
              // Third attempt after 600ms
              setTimeout(() => {
                console.log('[WallcoveringAbstract] Third scroll attempt');
                if (!attemptScroll(3)) {
                  // Final attempt after 800ms
                  setTimeout(() => {
                    console.log('[WallcoveringAbstract] Final scroll attempt');
                    attemptScroll(4);
                  }, 200);
                }
              }, 200);
            }
          }, 200);
        }
      }, 200); // Increased initial timeout for mobile
      
      return () => {
        console.log('[WallcoveringAbstract] Cleaning up scroll timeout');
        clearTimeout(timer1);
      };
    }
  }, [location.search, hasScrolledToTarget, visibleItems]);

  useEffect(() => {
    const updateScreenType = () => {
      const width = window.innerWidth;
      if (width <= 635) {
        setScreenType('mobile');
      } else if (width >= 636 && width <= 788) {
        setScreenType('tablet');
      } else if (width >= 800 && width <= 1244) {
        setScreenType('mid-desktop');
      } else {
        setScreenType('laptop');
      }
    };

    updateScreenType(); // Initial check
    window.addEventListener('resize', updateScreenType);
    return () => window.removeEventListener('resize', updateScreenType);
  }, []);

  const renderScreenComponent = () => {
    if (screenType === 'tablet') {
      return <WallcoveringsabstractTablet visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
    }
    if (screenType === 'mid-desktop') {
      return <WallcoveringsabstractMidDesktop visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
    }
    if (screenType === 'laptop') {
      return <WallcoveringsabstractLaptop visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
    }
    return <WallcoveringsabstractMobile visibleItems={visibleItems} lastCardRef={lastCardRef} cardRefs={cardRefs} />;
  };

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      {renderScreenComponent()}

      {visibleItems >= walldata.length && (
        <div className="text-center text-gray-500 py-8">
          You've reached the end of the collection!
        </div>
      )}

      <OurInformation />
    </div>
  );
};

export default Wallcoveringsabstract;































// import React from 'react';

// import { Link } from 'react-router-dom';

// import { walldata } from '../Config/wallcoveringabstractdata';

// import WallCards from "../Components/abstractCards";



// const Wallcoveringsabstract = () => {

//   return (

//     <div className="overflow-hidden p-0 sm:p-5">

//       <div className='services__area pt-10 hidden sm:block' id='services'>

//         <h2 className='text-xl font-serif pl-20 pb-10 underline'>Abstract Wallpapers</h2>

//       </div>

      
      
//       <div className='grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 px-4 sm:px-0'>

//         {walldata.map((it, index) => (

//           <Link 

//             to={`/wallcoverings/abstract/desc/${index + 1}`}

//             key={index}

//             className="w-full"

//           >

//             <div className="h-full">

//               <WallCards 

//                 ImgSrc={it.Img} 

//                 title={it.title} 

//                 desc={it.desc} 

//                 btn={it.btn}

//               />

//             </div>

//           </Link>

//         ))}

//       </div>

//     </div>

//   );

// }



// export default Wallcoveringsabstract;































// import React from 'react';

// import { Link } from 'react-router-dom';

// import { walldata } from '../Config/wallcoveringdata'; // Assuming you have the data in this file



// const Wallcoverings = () => {

//   return (

//     <div className="overflow-hidden p-0 sm:p-5">

//       <div className='services__area pt-10 hidden sm:block' id='services'>

//         <h2 className='text-xl font-serif pl-20 pb-10 underline'>Nature Wallpapers</h2>

//       </div>



//       <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center'>

//         {walldata.map((item, index) => (

//           <div className="relative group w-full h-full" key={index}>

//             {/* Link to the corresponding image's description page using its index */}

//             <Link to={`/wallcoverings/nature/desc/${index + 1}`}>

//               {/* Image with hover effect */}

//               <img

//                 src={item.Img}

//                 alt={item.title}

//                 className="w-full h-auto object-cover transition-transform duration-300 ease-in-out group-hover:scale-105" // Scale up on hover

//               />

//               {/* Hover effect and title display */}

//               <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white p-2 text-center transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100">

//                 {item.title}

//               </div>

//             </Link>

//           </div>

//         ))}

//       </div>

//     </div>

//   );

// };



// export default Wallcoverings;



//               <img


//                 src={item.Img}


//                 alt={item.title}


//                 className="w-full h-auto object-cover transition-transform duration-300 ease-in-out group-hover:scale-105" // Scale up on hover


//               />


//               {/* Hover effect and title display */}


//               <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white p-2 text-center transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100">


//                 {item.title}


//               </div>


//             </Link>


//           </div>


//         ))}


//       </div>


//     </div>


//   );


// };



// export default Wallcoverings;



